module.exports = __webpack_public_path__ + "img/dianhua.f9dcf567.png";